"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const containerStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
};
class BundleError extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.onLine = true;
        this.fullReload = () => {
            location.reload();
        };
    }
    componentWillMount() {
        this.onLine = navigator.onLine;
    }
    render() {
        return (react_1.default.createElement("div", { style: containerStyle },
            react_1.default.createElement("div", { style: { paddingBottom: "16px" } }, this.onLine ? react_1.default.createElement("div", null, "Error") : react_1.default.createElement("div", null, "No connection")),
            react_1.default.createElement("button", { onClick: this.fullReload }, "Reload")));
    }
}
exports.BundleError = BundleError;
exports.isAsyncComponent = (component) => {
    return Boolean(component.load);
};
exports.asyncComponent = (componentLoader) => {
    let Component = null;
    let isError = false;
    const state = {
        loaded: false,
        loading: false,
    };
    const load = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (Component) {
            return;
        }
        if (state.loading) {
            return;
        }
        try {
            state.loading = true;
            const loaderResponse = yield componentLoader();
            const _Component = loaderResponse.default;
            Component = _Component;
            isError = false;
            state.loaded = true;
        }
        catch (e) {
            console.error(e);
            isError = true;
        }
        state.loading = false;
    });
    function AsyncComponent(props) {
        react_1.default.useEffect(() => {
            load();
        }, []);
        if (!state.loaded) {
            return null;
        }
        if (Component) {
            return react_1.default.createElement(Component, Object.assign({}, props));
        }
        if (isError) {
            return react_1.default.createElement(BundleError, null);
        }
        return null;
    }
    AsyncComponent.load = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        yield load();
        return Component || BundleError;
    });
    return AsyncComponent;
};
//# sourceMappingURL=async-component.js.map